import { useGetMagazineByAuthorPublicIdQuery } from '@/hooks/magazine/magazine.gql.impl';
import { GetMagazineByAuthorPublicIdQuery, GetMagazineByAuthorPublicIdQueryVariables } from '@/types/bff/gql-schema';
import { QueryClient } from '@tanstack/react-query';
import { MagazineByAuthorPublicIdModel, MagazineByAuthorPublicIdVo } from '../model/magazine';

interface UseGetMagazineByAuthorPublicId {
  authorPublicId: string;
  page: number;
}

const parseMagazineByAuthorPublicId = (data: GetMagazineByAuthorPublicIdQuery): MagazineByAuthorPublicIdVo => {
  return {
    totalCount: data.magazineByAuthorPublicId.totalCount,
    totalPageCount: data.magazineByAuthorPublicId.totalPageCount,
    magazines: data.magazineByAuthorPublicId.magazines.map(
      (magazine) =>
        new MagazineByAuthorPublicIdModel({
          createdAt: magazine.createdAt,
          description: magazine.description,
          titleImageUrl: magazine.titleImageUrl,
          magazinePid: magazine.magazinePid,
          mobileDescription: magazine.mobileDescription,
          title: magazine.title,
          mobileTitle: magazine.mobileTitle,
        })
    ),
  };
};
const DEFAULT_PAGE_SIZE = 10;
const useGetMagazineByAuthorPublicId = ({ authorPublicId, page }: UseGetMagazineByAuthorPublicId) => {
  const { data: magazineByAuthorPublicId } = useGetMagazineByAuthorPublicIdQuery(
    {
      authorPublicId,
      pagingRequest: {
        page,
        limit: DEFAULT_PAGE_SIZE,
      },
    },
    {
      select: parseMagazineByAuthorPublicId,
    }
  );

  return { magazineByAuthorPublicId };
};

export default useGetMagazineByAuthorPublicId;

useGetMagazineByAuthorPublicId.getKey = (variables: GetMagazineByAuthorPublicIdQueryVariables) => {
  return useGetMagazineByAuthorPublicIdQuery.getKey(variables);
};

useGetMagazineByAuthorPublicId.prefetchQuery = async (
  queryClient: QueryClient,
  variables: GetMagazineByAuthorPublicIdQueryVariables
) => {
  await queryClient.prefetchQuery(
    useGetMagazineByAuthorPublicIdQuery.getKey(variables),
    useGetMagazineByAuthorPublicIdQuery.fetcher(variables)
  );
};
